import React, { Suspense } from 'react';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './msalConfig';
import './i18n';
import App from './containers/App/App';
import importIcons from './shared/icons';
import Maintenance from './containers/App/Maintenance';

importIcons();

const root = createRoot(document.getElementById('root')!);

const onMaintenence = JSON.parse(process.env.REACT_APP_ON_MAINTENANCE || 'false');
const isRelease = !!process.env.REACT_APP_CLIENT_ID;

const loadingDiv = (
  <div className="load">
    <div className="load__icon-wrap">
      <svg className="load__icon">
        <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
      </svg>
    </div>
  </div>
);

//
//
let isReload = false;
try {
  const perfEntries = window.performance.getEntriesByType('navigation');
  if (perfEntries && perfEntries.length > 0) {
    //
    const navEntry = perfEntries[0] as PerformanceNavigationTiming;
    isReload = navEntry.type === 'reload';
  } else if (window.performance.navigation) {
    //
    isReload = window.performance.navigation.type === 1;
  }
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn('No se pudo detectar el tipo de navegación', e);
}

// ---
// msalConfig.ts fija cacheLocation: 'localStorage' - el flag de interacción
// en curso vive ahí, no en sessionStorage.
if (isReload) {
  Object.keys(localStorage).forEach((key) => {
    if (key.includes('msal.interaction.status')) {
      localStorage.removeItem(key);
    }
  });
}

const startApp = () => {
  const app = onMaintenence ? (
    <Suspense fallback={loadingDiv}>
      <Maintenance />
    </Suspense>
  ) : (
    <App />
  );

  const application = isRelease ? <MsalProvider instance={msalInstance}>{app}</MsalProvider> : app;

  root.render(<React.StrictMode>{application}</React.StrictMode>);
};

// ---
if (isRelease) {
  // MSAL v3 requiere inicializar la instancia antes de cualquier otra
  // llamada que dispare una interacción (handleRedirectPromise,
  // loginRedirect, acquireTokenSilent) - a diferencia de v2, ahora tiran
  // BrowserAuthError("uninitialized_public_client_application") si se
  // llaman antes de que initialize() resuelva (Fase 3, F3-6).
  msalInstance
    .initialize()
    .then(() => msalInstance.handleRedirectPromise())
    .then((response) => {
      //
      if (response && response.account) {
        msalInstance.setActiveAccount(response.account);
        startApp();
        return undefined;
      }
      //
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
        startApp();
        return undefined;
      }
      //
      return msalInstance.loginRedirect({
        scopes: [process.env.REACT_APP_SCOPE || ''],
      });
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('MSAL Error:', error);
      const errorStr = String(error);
      //
      if (errorStr.includes('interaction_in_progress') || errorStr.includes('state_mismatch')) {
        // cacheLocation: 'localStorage' (msalConfig.ts) - el flag de
        // interacción en curso vive ahí; limpiar sólo sessionStorage lo deja
        // pegado y esto entra en loop de reload infinito.
        sessionStorage.clear();
        localStorage.clear();
        window.location.reload();
      } else if (msalInstance.getAllAccounts().length > 0) {
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
        startApp();
      }
    });
} else {
  startApp();
}
